<template>
	<v-container fluid>
		<!--menu-->
		<v-row justify="end" class="mt-n12 mr-8 mb-2">
			<main-menu></main-menu>
		</v-row>
		<v-row justify="center" class="secondary--text title my-2">
			Partners
		</v-row>
		<div v-if="!loading">
			<v-container>
		
			</v-container>
		</div>
		<div v-else>
			<loader></loader>
		</div>
					
	</v-container>
</template>
<script>
	import MainMenu from '../layouts/Menu.vue'
	import Loader from '../layouts/Loader.vue'

	export default {
		data () {
			return {}
		},
		components: {MainMenu, Loader}
	}	
</script>